import { IMessageResponse, EMessageResponseTypes } from '@cian/push-manager';
import type { ILogger } from '@cian/logger';

import { getSubscriptionData } from '../../shared/utils/localStorage/storage';
import { prepareOrigin } from './prepareOrigin';

interface IDependencies {
  logger: ILogger;
}

function postMessageToParent(message: IMessageResponse, origin: string) {
  parent.postMessage(JSON.stringify(message), origin);
}

export async function registerWorker(
  dependencies: IDependencies,
  workerSrc: string,
): Promise<ServiceWorkerRegistration | null> {
  let serviceWorkerRegistration = null;

  if (window && navigator && 'serviceWorker' in navigator) {
    serviceWorkerRegistration = await navigator.serviceWorker.register(workerSrc);
  }

  const message: IMessageResponse = {
    type: EMessageResponseTypes.subscriptionStatus,
    value: Boolean(getSubscriptionData()),
  };
  const origin = prepareOrigin(dependencies, document.referrer);

  postMessageToParent(message, origin);

  return serviceWorkerRegistration;
}
